import {
  Box,
  Breadcrumbs,
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { LinkRouter } from "components/BreadCrumbs";
import useTitle from "hooks/useTitle";
import { useNavigate, useParams } from "react-router-dom";

import { useState } from "react";
import { ResType } from "types";
import { useQuery } from "react-query";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import { StyledText1 } from "views/atom-pro/styles";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import { formatToRupeess } from "utils/formattedAmount";
import Loader from "components/Loader";
import { getDemandData } from "api/services/automation/income-tax";
import moment from "moment";
import AccessDenied from "./Access/accessDenide";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Height } from "@mui/icons-material";
import PanDemandResponseModal from "./PanDemandResponseModal";
import DetailField from "./Utils/DetailField";

interface StyledSpanProps {
  bgColor?: string; // Define bgColor prop here
}

const StyledSpan = styled("span")<StyledSpanProps>(({ theme, bgColor }) => ({
  backgroundColor: bgColor || "#fffff",
  padding: "3px",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "5px",
  color: "#222222",
}));

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function OutstandingDemandView() {
  useTitle("Demands");
  const params = useParams();
  const navigate = useNavigate();
  const [state, setInitialState] = useState<any>({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>({});

  const { data, isLoading: demandIsLoading }: ResType = useQuery(
    ["income-demands", params.id],
    getDemandData,
    {
      onSuccess: (res) => {
        setInitialState(res?.data);
      },
    }
  );

  const generateAssessmentYear = (assessmentYear) => {
    if (!assessmentYear || assessmentYear === "0" || assessmentYear === "") {
      return "NA";
    } else if (!isNaN(assessmentYear) && assessmentYear.length === 4) {
      const year = parseInt(assessmentYear);
      const nextYear = (year + 1).toString().slice(-2);
      return `AY ${year}-${nextYear}`;
    } else {
      return assessmentYear;
    }
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleItemClick = (fileName, type) => {
    const urlStart = `https://vider-prod-bucket.s3.ap-south-1.amazonaws.com/`;
    const amazon = type == "AMAZON" || type == null;
    const bharachCloud = type == "BHARATHCLOUD" || type == null;
    const url = amazon ? (urlStart + fileName) : bharachCloud ? (`${fileName['endPoint']}/${fileName['key']}`) : fileName?.key;
    window.open(url, '_blank');
  };

  const getFileName = (filePath, type) => {
    if (type == "AMAZON" || type == null) {
      const parts = filePath.split("/");
      return parts[parts.length - 1];
    } else if (type == 'MICROSOFT' || type == "GOOGLE") {
      const parts = filePath['name'].split('/');
      return parts[parts.length - 1];
    } else if (type == 'BHARATHCLOUD') {
      const parts = filePath['key'].split('/');
      return parts[parts.length - 1];

    }
    return null

  };


  const TimelineComponent = ({ dateOfDemandRaised }) => {
    return (
      <Timeline position="left">
        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            align="right"
            variant="body2"
            color="text.secondary"
          >
            {state?.currentStatus ? "Current Status" : ""}
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot
              sx={{
                backgroundColor: "#182F53",
                borderRadius: "50%",
                width: "16px",
                height: "16px",
                boxShadow: "inset 0 0 0 2px #fff",
              }}
            />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent sx={{ py: "12px", px: 2 }}>
            <Typography variant="h6" component="span">
              {state?.currentStatus ? state?.currentStatus : ""}
            </Typography>
          </TimelineContent>
        </TimelineItem>
        {dateOfDemandRaised.map((item, index) => (
          <TimelineItem key={index}>
            <TimelineOppositeContent
              sx={{ m: "auto 0" }}
              align="right"
              variant="body2"
              color="text.secondary"
            >
              {Object.keys(item)[0] || ""}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot
                sx={{
                  backgroundColor: "#182F53",
                  borderRadius: "50%",
                  width: "16px",
                  height: "16px",
                  boxShadow: "inset 0 0 0 2px #fff",
                }}
              />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: "12px", px: 2 }}>
              <Typography variant="h6" component="span">
                {moment(item[Object.keys(item)[0]]).format("DD MMM YYYY") || ""}
              </Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    );
  };
  if (demandIsLoading) return <Loader />;
  return (
    <>
      {!state && <AccessDenied />}

      {state && (
        <>
          <Box height="80vh" overflow="auto">
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon fontSize="small" />
              <Typography variant="subtitle2" ml={1}>
                Outstanding Demand List
              </Typography>
            </IconButton>
            <Grid container>
              <Grid item xs={9} sx={{ borderRight: "1px solid #d9d9d9" }}>
                <Typography
                  sx={{ marginBottom: "20px", color: "#2F343A", paddingLeft: "10px" }}
                  variant="subtitle1"
                >
                  Demand Info (DIN):{state.demandReferenceNo}
                </Typography>
                <Typography sx={{ paddingLeft: "10px" }} variant="subtitle2">
                  Rectification Right
                </Typography>

                
                <Grid item xs={12} p={1}>
                  <Grid container spacing={2}>
                    <DetailField label="PAN" value={state?.pan} />

                    <DetailField
                      label="Assessment Year"
                      value={state?.assessmentYear}
                      format={generateAssessmentYear}
                    />

                    <DetailField label="Current Status" value={state?.currentStatus} />

                    <DetailField
                      label="Demand Raised Date"
                      value={state?.demandDateMilli}
                      format={(v) => moment(v * 1).format("DD MMM YYYY")}
                    />

                    <DetailField label="Section" value={state?.sectionCodeText} />
                    <DetailField label="Mode Of Service" value={state?.modeOfService} />
                    <DetailField label="AO Response Type" value={state?.aoResponseType} />

                    <DetailField
                      label="Date Of Service Notice"
                      value={state?.dateOfServiceNotice}
                      format={(v) => moment(Number(v)).format("DD-MM-YYYY HH:mm A")}
                    />

                    <DetailField label="Response Type" value={state?.responseType} xs={6} />
                    <DetailField label="Response Reason" value={state?.responseReason} />
                    <DetailField label="AO Response Reason" value={state?.aoResponseReason} />

                    <DetailField
                      label="Current Status Date"
                      value={state?.currentStatusDate}
                      format={(v) => moment(Number(v)).format("DD-MM-YYYY HH:mm A")}
                    />

                    <DetailField label="Interest Us" value={state?.interestUs} />
                    <DetailField
                      label="Outstanding Demand Amount Wo Interest"
                      value={state?.outstandingDemandAmountWoInterest}
                    />

                    <DetailField
                      label="AO Response Date"
                      value={state?.aoResponseDate}
                      format={(v) => moment(Number(v)).format("DD-MM-YYYY HH:mm A")}
                    />
                  </Grid>
                </Grid>

                <Box>
                  <Box
                    padding={1}
                    sx={{ backgroundColor: "#F6F6F6" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">Demand Amount Breakup</Typography>
                    {state?.latestDemandResponse &&
                      Object.keys(state.latestDemandResponse).length > 0 && (
                        <Button color="info" variant="outlined" onClick={() => openModal()}>
                          View Response
                        </Button>
                      )}{" "}
                  </Box>
                </Box>
                <TableContainer sx={{ overflowX: "auto"}}>
                  <Table
                    size="small"
                    sx={{
                      minWidth: 900,
                      border: "1px solid #D9D9D9",
                      borderCollapse: "collapse",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: "#2F2F2F",
                            backgroundColor: "#F7F7F7",
                            border: "1px solid #D9D9D9",
                          }}
                        >
                          Interest Start Date
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: "#2F2F2F",
                            backgroundColor: "#F7F7F7",
                            border: "1px solid #D9D9D9",
                          }}
                        >
                          Accrued Interest Computation Updated As On
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: "#2F2F2F",
                            backgroundColor: "#F7F7F7",
                            border: "1px solid #D9D9D9",
                          }}
                        >
                          Time Period
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: "#2F2F2F",
                            backgroundColor: "#F7F7F7",
                            border: "1px solid #D9D9D9",
                          }}
                        >
                          Accrued Interest Computed
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: "#2F2F2F",
                            backgroundColor: "#F7F7F7",
                            border: "1px solid #D9D9D9",
                          }}
                        >
                          Outstanding Demand Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ border: "1px solid #D9D9D9" }}>
                          {state?.interestStartDate
                            ? moment(state.interestStartDate).format("DD MMM YYYY")
                            : "--"}
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #D9D9D9" }}>
                          {moment().format("DD MMM YYYY")}
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #D9D9D9" }}>
                          {state?.timePeriod ? `${state.timePeriod} Months` : "--"}
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #D9D9D9" }}>
                          <Box
                            display="inline-flex"
                            alignItems="center"
                            sx={{
                              backgroundColor: "#EAFFE7",
                              fontWeight: 600,
                              px: 1,
                              py: 0.5,
                              borderRadius: "4px",
                            }}
                          >
                            <CurrencyRupeeIcon sx={{ width: "15px" }} />
                            {formatToRupeess(state?.accruedInterestComputed)}
                          </Box>
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #D9D9D9" }}>
                          <Box
                            display="inline-flex"
                            alignItems="center"
                            sx={{
                              backgroundColor: "#EAFFE7",
                              fontWeight: 600,
                              px: 1,
                              py: 0.5,
                              borderRadius: "4px",
                            }}
                          >
                            <CurrencyRupeeIcon sx={{ width: "15px" }} />
                            {formatToRupeess(state?.outstandingDemandAmount)}
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={3} p={0}>
                <Typography variant="subtitle2" sx={{ color: "#667085", paddingLeft:'10px' }}>
                  Timeline
                </Typography>
                {state && state.dateOfDemandRaised && (
                  <TimelineComponent dateOfDemandRaised={state?.dateOfDemandRaised} />
                )}
              </Grid>
            </Grid>
            <PanDemandResponseModal state={state} isModalOpen={isModalOpen} closeModal={closeModal} style={style} handleItemClick = {handleItemClick} getFileName={getFileName}/>
          </Box>
        </>
      )}
    </>
  );
}

export default OutstandingDemandView;
